import React from "react";
import HelpModal from "./HelpModal";
import { Text } from "@mantine/core";
import { BingoGame } from "bingo/types/bingo-game.model";
interface BingoTopBoxProps {
  isPreviewMode: boolean;
  showNumberNotDrawnMessage: boolean;
  showBingoButton: boolean;
  handleBingoClick: () => void;
  topText?: string;
  bingoGame: BingoGame;
}

export const BingoTopBox: React.FC<BingoTopBoxProps> = ({
  isPreviewMode,
  showNumberNotDrawnMessage,
  showBingoButton,
  handleBingoClick,
  topText,
  bingoGame,
}) => {
  if (isPreviewMode) {
    return (
      <div className="flex items-center gap-2 w-full">
        <div className="w-full">
          <Text className="text-center">{topText}</Text>
        </div>
        <div className="invisible">&nbsp;</div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 w-full">
      <div className="w-full">
        <Text
          className={`text-center text-red-600 ${
            showNumberNotDrawnMessage ? "visible" : "invisible"
          }`}
        >
          {bingoGame.bingoTemplateSnapshot.frontOfficeMessages.notDrawnNumber}
        </Text>
      </div>
      <div>
        <HelpModal bingoGame={bingoGame} />
      </div>
    </div>
  );
};

export default BingoTopBox;
